import { useMutation } from '@tanstack/react-query';

import { sendEmailVerification } from '../../../api/account/sendEmailVerification';

export function useSendVerificationEmail() {
  return useMutation({
    mutationFn: sendEmailVerification,
  });
}
